import cn from 'classnames';

const UserFlowTypographySubdued = ({ children, classes }: { children: string; classes?: string }) => (
  <div className={cn(classes, 'text-align-center n700')}>{children}</div>
);

export default UserFlowTypographySubdued;
